/**
 * AuthGate — redirects to /login if user is not authenticated.
 * Tries to restore session from sessionStorage on mount.
 */
import { useEffect, useState, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { apiUrl } from '../../config';

export default function AuthGate({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const setAuth = useAuthStore((s) => s.setAuth);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Try restoring session from sessionStorage
    if (!token) {
      const stored = localStorage.getItem('dukkan_token');
      if (stored) {
        // Verify the token is still valid by calling /api/auth/me
        fetch(apiUrl('/api/auth/me'), {
          headers: { Authorization: `Bearer ${stored}` },
        })
          .then((res) => {
            if (res.ok) return res.json();
            throw new Error('expired');
          })
          .then((u) => {
            setAuth(u, stored);
            setChecking(false);
          })
          .catch(() => {
            localStorage.removeItem('dukkan_token');
            setChecking(false);
          });
        return;
      }
    }
    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', color: 'var(--text-secondary)' }}>
        Loading...
      </div>
    );
  }

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
